"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTransit = void 0;
const TransitContext_1 = require("./TransitContext");
const react_1 = __importDefault(require("react"));
exports.useTransit = () => {
    const context = react_1.default.useContext(TransitContext_1.TransitContext);
    if (context === undefined) {
        throw new Error('You must wrap your application with <TransitProvider /> in order to useTransit().');
    }
    return context;
};
exports.default = exports.useTransit;
//# sourceMappingURL=useTransit.js.map